"use client";

import { openCookieSettings } from "@/components/cookie-consent/consent";

export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={openCookieSettings}
      className={className ?? "transition-colors hover:text-white"}
    >
      Cookie Settings
    </button>
  );
}
